import { ArchivedExternalSuppliersPanel } from "@/components/organisms";

export const ArchivedExternalSuppliers = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col py-2">
      <ArchivedExternalSuppliersPanel />
    </div>
  );
};
